import axios from "axios";

const getApiBaseUrl = () => {
  const source = localStorage.getItem("source");

  switch (source) {
    case "formaxpay":
      return "https://api.formaxpay.com/api/";
    case "rechargepos":
      return "https://api.formaxpay.com/api/";
    // return "http://192.168.0.107:5001/api/";
    case "api":
    default:
      return "https://api.formaxpay.com/api/";
    // return "http://192.168.0.107:5001/api/";
  }
};

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

// Dynamically update baseURL and token before each request
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  const baseURL = getApiBaseUrl();

  config.baseURL = baseURL;

  if (token) {
    config.headers["x-access-token"] = `${token}`;
  }

  return config;
});

export default axiosInstance;
